import {useParams} from 'react-router'

export type UrlParams = Record<'plantCode', string>

export const useUrlParam = (paramKey: keyof UrlParams) => {
  const urlParams = useParams<Partial<UrlParams>>()
  const parameter = urlParams[paramKey]
  if (parameter === undefined) {
    throw new Error(`Could not obtain url parameter with name ${paramKey}`)
  }
  return parameter
}
